import axios, { AxiosStatic } from 'axios';
import { BaseHttpTransport } from '@axmit/transport';
import { ISkillCollection, ISkillCollectionFilter, ISkillModel } from 'entities/Skill/Skill.models';

const basePath = '/skills';

class SkillTransport extends BaseHttpTransport<AxiosStatic, ISkillModel, ISkillCollection, void, void, ISkillCollectionFilter> {}

export const skillTransport = new SkillTransport(basePath, axios);
